import styled from 'styled-components'
import { customTheme } from '../../../../styles/theme'

export const AlertDialogOverlay = styled.div`
  background: rgba(0, 0, 0, 0.35);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 70;
  pointer-events: none;
`

export const AlertDialogContent = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 1999;
  transform: translate(-50%, -50%);

  width: 600px;
  max-width: 95%;
  padding: 30px;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  background: rgba(255, 255, 255, 0.2);
  border: 1.84534px solid rgba(188, 188, 188, 0.74);
  box-shadow: 0px 7.23636px 35.2773px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(54.4375px);
  border-radius: 33px;
`

export const AlertDialogHeader = styled.div``

export const AlertDialogBody = styled.div`
  padding: 10px;
  margin-bottom: 20px;
  text-align: center;
  font-size: ${customTheme.fontSizes.md};
  font-weight: bold;
`

export const AlertDialogFooter = styled.div`
  padding: 10px;
  width: 100%;
  display: flex;
  justify-content: center;

  button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #5aff5a;
    border: 2px solid #606060;
    opacity: 1;
    box-sizing: border-box;
    box-shadow: 0px 4px 16px rgb(0 0 0 / 50%);
    border-radius: 10vw;
    font-family: Poppins;
    font-weight: bold;
    font-size: 18px;
    line-height: 1.2;
    color: #000000;
    cursor: pointer;
    padding: 15px;
  }
`
